import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    filters: {
      dateFrom: null,
      dateTo: null,
      limit: 10,
    },
    fetchingResults: false,
    results: [],
  },
  reducers: {
    updateFilterValues: (state, action) => {
      state.filters.dateFrom = action.payload.dateFrom;
      state.filters.dateTo = action.payload.dateTo;
      state.filters.limit = action.payload.limit;
    },
    updateFetchingState: (state, action) => {
      state.fetchingResults = action.payload.state;
    },
    search: (state, action) => {
      state.results = action.payload.data;
      state.fetchingResults = false;
    },
    updateResults: (state, action) => {
      state.results = action.payload;
    },
  },
});

export default searchSlice;